import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { InvoiceListProps } from "models/propTypes/articlePropTypes";
import { IconDefinitionConstants, TableConstants } from "utils/constants";
import { InvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import { ViewPanel } from "components/common";
import { InvoiceListView } from "components/invoice";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceList: React.FC<InvoiceListProps> = (props) => {
  const filter: InvoiceFormTypes.Filter = React.useMemo(
    () => ({ articles: [{ id: props.articleId, value: "" }] }),
    [props.articleId]
  );

  return (
    <>
      {props.articleId && (
        <ViewPanel
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.LatestInvoices)}
          icon={IconDefinitionConstants.WSend}
        >
          <InvoiceListView tableKey={TableConstants.ArticleInvoiceList} filter={filter} includeSummary={false} />
        </ViewPanel>
      )}
    </>
  );
};
export default InvoiceList;
